import { render, staticRenderFns } from "./layout-content-window.vue?vue&type=template&id=4d84f0e3&scoped=true&"
import script from "./layout-content-window.vue?vue&type=script&lang=js&"
export * from "./layout-content-window.vue?vue&type=script&lang=js&"
import style0 from "./layout-content-window.vue?vue&type=style&index=0&id=4d84f0e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d84f0e3",
  null
  
)

export default component.exports